import { call, put, takeLatest } from "redux-saga/effects";
import { queueApi } from "../../../api/queue/queueApi";
import { setQueueToken } from "../../../helpers/queueToken";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import { IQueueStatus } from "../../../model/respone/queue/IQueueStatus";
import { eQueueActionTypeIds } from "../../action-types/queue/IQueueActions";
import { rootActions } from "../../actions/rootActions";

export function* queueSaga(): any {
    yield takeLatest(eQueueActionTypeIds.LOAD_STATUS_START, loadStatusWorker);
}

function* loadStatusWorker(): any {
    const res: IBaseRespone<IQueueStatus> = yield call(queueApi.GetStatus);
    if (res.is_success && res.data) {
        if (res.data.token) setQueueToken(res.data.token);
        yield put(rootActions.queue.LOAD_STATUS_SUCCESS(res.data));
    } else {
        yield put(rootActions.queue.LOAD_STATUS_ERROR(res.message || "Không thể tải trạng thái hàng chờ."));
    }
}
